"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const steps = [{
  num: "01",
  title: "ご予約",
  desc: "電話またはフォームでご連絡。日程を調整します。"
}, {
  num: "02",
  title: "初回面接",
  desc: "相談内容・成育歴・期待することをお聞きします。"
}, {
  num: "03",
  title: "アセスメント面接",
  desc: "見立てと今後の方針を検討します（3〜5回程度）。"
}, {
  num: "04",
  title: "継続面接",
  desc: "課題に一緒に取り組みます（期間は人によって異なります）。"
}, {
  num: "05",
  title: "フォローアップ面接",
  desc: "終了後3〜6ヶ月のタイミングで、ご希望に応じて状況を確認します。"
}];
export default function Flowchart() {
  return <section id="flowchart" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-12">
          <p className="text-primary font-bold font-default mb-3">Flow</p>
          <h1 className="text-3xl md:text-4xl font-bold text-primary font-default leading-tight mb-4">カウンセリングの流れ</h1>
          <Separator className="w-12 h-0.5 bg-primary mb-8" />
          <p className="text-foreground leading-relaxed font-default">四谷三丁目駅から徒歩約4分、曙橋駅から徒歩約7分の心理カウンセリングルームです。ご予約からフォローアップまで、5つのステップでご案内します。</p>
        </div>

        <div className="flex flex-col md:flex-row md:items-start">
          {steps.map((step, i) => <React.Fragment key={i}>
              <div className="flex flex-row md:flex-col md:items-center md:text-center flex-1 min-w-0 gap-4 md:gap-0">
                <div className="flex-shrink-0 flex items-center justify-center rounded-full size-14 md:size-16 bg-primary text-primary-foreground text-lg font-bold font-default">{step.num}</div>
                <div className="md:mt-4 flex-1 md:flex-none">
                  <p className="font-bold text-foreground font-default">{step.title}</p>
                  <p className="text-sm text-muted-foreground leading-relaxed mt-2 md:max-w-[180px]">{step.desc}</p>
                </div>
              </div>
              {i < steps.length - 1 && <>
                  <div className="md:hidden ml-7 h-6 border-l-2 border-dashed border-primary/40" aria-hidden="true" />
                  <div className="hidden md:block mt-8 w-6 flex-shrink-0 border-t-2 border-dashed border-primary/40" aria-hidden="true" />
                </>}
            </React.Fragment>)}
        </div>

      </div>
    </section>;
}